module.exports = __webpack_public_path__ + "img/2.9ac4bb78.jpg";